var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:folder-thin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.6875 29.0938H49.6355L38.7291 18.1913C38.3042 17.7629 37.7985 17.4231 37.2412 17.1918C36.6839 16.9605 36.0863 16.8422 35.4829 16.8438H15.3125C14.0942 16.8438 12.9257 17.3277 12.0642 18.1892C11.2027 19.0507 10.7188 20.2192 10.7188 21.4375V76.7999C10.7208 77.9546 11.1804 79.0615 11.9969 79.8781C12.8135 80.6946 13.9204 81.1542 15.0752 81.1563H83.0282C84.1559 81.1553 85.2371 80.7068 86.0344 79.9095C86.8318 79.1121 87.2802 78.0309 87.2812 76.9032V33.6875C87.2812 32.4692 86.7973 31.3007 85.9358 30.4392C85.0743 29.5777 83.9058 29.0938 82.6875 29.0938ZM13.7812 21.4375C13.7812 21.0314 13.9426 20.6419 14.2297 20.3548C14.5169 20.0676 14.9064 19.9063 15.3125 19.9063H35.4829C35.8878 19.907 36.2759 20.068 36.5624 20.3542L45.302 29.0938H13.7812V21.4375ZM84.2188 76.9032C84.2177 77.2187 84.092 77.5209 83.8689 77.7439C83.6459 77.967 83.3436 78.0928 83.0282 78.0938H15.0752C14.7323 78.0928 14.4038 77.9561 14.1613 77.7137C13.9189 77.4712 13.7823 77.1427 13.7812 76.7999V32.1563H82.6875C83.0936 32.1563 83.4831 32.3176 83.7703 32.6048C84.0574 32.8919 84.2188 33.2814 84.2188 33.6875V76.9032Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.298359cb3935746a9c0889b2d744d243.svg";
export { ForwardRef as ReactComponent };